import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import ChangePassword from '@src/routes/members/components/account/change-password'
import PersonalInformation from '@src/routes/members/components/account/personal-information'
import QrCode from '@src/routes/members/components/account/qr-code'
import MemberSettings from '@src/routes/members/components/account/settings'
import { MemberActions } from '@src/routes/members/components/account/member-actions'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { track } from '@src/util/functions'
import DownloadLegalDocuments from '@src/components/download-legal/download-legal'

import './account.sass'

@Component
export default class MemberAccount extends Vue {

  constructor () {
    super()
    track('/members/account')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.ACCOUNT')}`
    this.scrollToRouteHash()
  }

  mounted () {
    this.scrollToRouteHash()
  }

  scrollToRouteHash () {
    if (!this.$route) return
    if (this.$route.hash !== '#deactivation') return
    this.$nextTick(() => {
      const element = document.getElementById('deactivation')
      if (element) element.scrollIntoView()
    })
  }

  render (h: CreateElement) {
    return <div class='member-account-wrapper scroll-content'>
      <PersonalInformation />

      <QrCode />

      <MemberSettings />

      <ChangePassword />

      <MemberActions />

      <Subtitle1>{this.$t('PAGE.MEMBERS.LEGAL.DOWNLOADS')}</Subtitle1>

      <Spacer />
      <DownloadLegalDocuments />
    </div>
  }
}
